/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import {
  InputV2,
  TipoEquipamentoSelectV2,
  TrueFalseSelectV2,
  DatePickerV2,
  ArquivoContainerV2,
} from '../../../components/v2';

const InformacaoBasicaTab = ({ values, setValues, errors, handleChange }) => (
  <Grid container spacing={1}>
    <Grid size={{ xs: 12, sm: 3 }}>
      <TipoEquipamentoSelectV2
        showEmpty
        isRequired
        onChange={(tipoEquipamento) => setValues({
          ...values,
          tipoEquipamento,
        })}
        value={values.tipoEquipamento}
        error={!!(errors && errors.tipoEquipamento)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <TrueFalseSelectV2
        error={!!(errors && errors.ativo)}
        isRequired
        label="Ativo"
        name="ativo"
        onChange={handleChange}
        value={values.ativo}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Num. Patrimônio"
        name="numPatrimonio"
        onChange={handleChange}
        value={values.numPatrimonio || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        error={!!(errors && errors.modelo)}
        isRequired
        label="Modelo"
        name="modelo"
        onChange={handleChange}
        value={values.modelo || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <InputV2
        label="Num. Série"
        name="numSerie"
        onChange={handleChange}
        value={values.numSerie || ''}
      />
    </Grid>
    {values.tipoEquipamento === 'DRONE' && (
      <>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Num. Série Camera"
            name="numSerieCamera"
            onChange={handleChange}
            value={values.numSerieCamera || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Código SISANT"
            name="codigoSisant"
            onChange={handleChange}
            value={values.codigoSisant || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <DatePickerV2
            label="Vencimento SISANT"
            onChange={(data) => setValues({ ...values, validoAteSisant: data })}
            value={values.validoAteSisant}
            showInput
          />
        </Grid>
      </>
    )}
    {['CELULAR', 'DRONE', 'RADIO'].includes(values.tipoEquipamento) && (
      <Grid size={{ xs: 12, sm: 3 }}>
        <InputV2
          label="Código ANATEL"
          name="codigoAnatel"
          onChange={handleChange}
          value={values.codigoAnatel || ''}
        />
      </Grid>
    )}
    {values.tipoEquipamento === 'DRONE' && (
      <Grid size={{ xs: 12, sm: 8 }}>
        <InputV2
          label="Apólice de seguro"
          name="numApoliceSeguro"
          onChange={handleChange}
          value={values.numApoliceSeguro || ''}
        />
      </Grid>
    )}
    {values.id && (
      <>
        <Grid size={{ xs: 12, sm: 6 }}>
          <InputV2
            label="Último Repasse/Colaborador"
            disabled
            value={values.ultimoRepasse || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Criado Por"
            disabled
            value={values.criadoPorName || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Data Inclusão"
            disabled
            value={values.dataInclusao || ''}
          />
        </Grid>
      </>
    )}
    <Grid size={{ xs: 12 }}>
      <InputV2
        label="Outras informações"
        name="informacao"
        onChange={handleChange}
        value={values.informacao || ''}
        rows={3}
        multiline
      />
    </Grid>
    <Grid size={{ xs: 12 }}>
      <ArquivoContainerV2
        arquivos={values.arquivos}
        onSave={(arquivos) => setValues({ ...values, arquivos })}
      />
    </Grid>
  </Grid>
);

InformacaoBasicaTab.propTypes = {
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  errors: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
};

export default InformacaoBasicaTab;
